// General CSS Styles
export const CLICKABLE = 'clickable';
export const HIGHLIGHTED = 'highlighted';
export const IMPORTANT_COLOR = 'important-color';
export const IMPORTANT_EVENT = 'important-event';
export const INVISIBLE = 'invisible';
export const UNCLICKABLE = 'unclickable';

// General Images
export const ARROW = 'images/arrow.png';
export const INCOME_ICON = 'images/income.png';
export const INCOME_ICON_HIGHLIGHTED = 'images/income-highlighted.png';

// Cube Images
export const DEBT_CUBE = 'images/cubes/debt.png';
export const INCOME_CUBE = 'images/cubes/income.png';
export const SECURITY_CUBE = 'images/cubes/security.png';
export const UNREST_CUBE = 'images/cubes/unrest.png';
export const WELFARE_CUBE = 'images/cubes/welfare.png';

// Cuts Image
export const DEBT_INCOME_CUT = 'images/cuts/debt-income.png';
export const DEBT_SECURITY_CUT = 'images/cuts/debt-security.png';
export const DEBT_UNREST_CUT = 'images/cuts/debt-unrest.png';
export const DEBT_WELFARE_CUT = 'images/cuts/debt-welfare.png';